export default __webpack_public_path__ + "static/media/GR00031-bullet.eb54f40d.svg";